import React, { useState, useContext, useEffect, useRef } from 'react';
import Helmet from '../../components/Helmet';
import Context from '../../container';
import PPT from './ppt';
import PureVideoModal from './pure-video-modal';
import Scene from './scene.tsx';
import Story from '../../components/AIP/story';


export default function (props) {
  const { dispatch } = useContext(Context);
  const [iframeHeight, setIframeHeight] = useState(500); // 初始高度
  const [videoModalVisible, setVideoModalVisible] = useState(false); // 视频模态框显示状态
  const [videoSrc, setVideoSrc] = useState(''); // 视频源
  const path = props.location.pathname
  const isLandingPage = path.replace(/[^a-zA-Z]/g, '') === 'ai' || path.includes('/ai/ai-native')
  const iframeRef = useRef(null);
  const resizeObserverRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (isLandingPage) {
      dispatch({ theme: 'dark' })
    } else {
      dispatch({ theme: undefined })
    }
  }, [isLandingPage])

  const handleIframeLoad = (event) => {
    try {
      // 清除之前可能存在的观察器
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }

      const iframe = event.target;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const iframeBody = iframeDoc.body;

      // 初始化高度
      const initialHeight = iframeBody.scrollHeight;
      setIframeHeight(initialHeight);

      // 创建 ResizeObserver 监听 iframe 内容高度变化
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const height = entry.target.scrollHeight;
          setIframeHeight(height);
        }
      });

      // 开始观察 body 元素
      resizeObserver.observe(iframeBody);
      resizeObserverRef.current = resizeObserver;

    } catch (error) {
      console.error('无法获取 iframe 内容高度:', error);
    }
  };

  // 组件卸载时清理观察器
  useEffect(() => {
    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, []);

  // 处理iframe发送的视频播放消息
  useEffect(() => {
    const handleMessage = (event) => {
      // 验证消息来源（可选，根据安全需求）
      if (event.data && event.data.type) {
        switch (event.data.type) {
          case 'PLAY_VIDEO':
            setVideoSrc(event.data.videoSrc);
            setVideoModalVisible(true);
            break;
          case 'CLOSE_VIDEO':
            setVideoModalVisible(false);
            setVideoSrc('');
            // 通知iframe视频已关闭
            if (iframeRef.current && iframeRef.current.contentWindow) {
              iframeRef.current.contentWindow.postMessage({
                type: 'VIDEO_CLOSED'
              }, '*');
            }
            break;
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // ESC键关闭视频模态框
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && videoModalVisible) {
        closeVideoModal();
      }
    };

    if (videoModalVisible) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [videoModalVisible]);

  // 关闭视频模态框
  const closeVideoModal = () => {
    setVideoModalVisible(false);
    setVideoSrc('');
    // 通知iframe视频已关闭
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({
        type: 'VIDEO_CLOSED'
      }, '*');
    }
  };

  // 处理视频播放错误
  const handleVideoError = (error) => {
    console.error('视频播放失败:', error);
    // 通知iframe视频播放错误
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({
        type: 'VIDEO_ERROR',
        error: error.message || '视频播放失败'
      }, '*');
    }
    closeVideoModal();
  };

  return (
    <React.Fragment>
      <Helmet title="AI-端点-Terminus-全链路解决方案" />
      {isLandingPage && <PPT />}
      {isLandingPage && <Story />}
      {isLandingPage && <Scene isLandingPage={isLandingPage}/>}
      <iframe
        ref={iframeRef}
        src={isLandingPage ? "/ai/ai-native.html" : `${path}.html`}
        onLoad={handleIframeLoad}
        className='no-scroll'
        scrolling="no"
        style={{ width: '100%', height: `${iframeHeight}px`, border: 'none', display: 'block', overflow: 'hidden' }}
        suppressHydrationWarning={true}
      />
      <PureVideoModal
        videoModalVisible={videoModalVisible}
        closeVideoModal={closeVideoModal}
        videoRef={videoRef}
        handleVideoError={handleVideoError}
        videoSrc={videoSrc}
      />
    </React.Fragment>
  );
}

